import Axois from '../utils/axios'
import EventEmitter from '../utils/eventEmitter';



export const loadDebitNotes = async () => {
  let response = await Axois.get('/debit-notes').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
    const responseData = await response.data;
    return responseData;
}


export const loadDebitNote = async (action) => {
  try {
    switch (action) {
      case 'new':
        let requests = await Axois.get('/setups/invoices');
        const responseData = await requests.data;
        return {...responseData, bill: {}, entry: { }};
        // return {journals: [], accounts:[], taxes: [], invoice: {}, entry:{},};

      default:
        let response = await Axois.get('/debit-notes/find/'+action);
        const responseJson = await response.data;
        return responseJson;
        // return {journals: [], accounts:[], taxes: [], entry:{}, transactions:[]};
    }
  }catch (err) {
    console.log(err);
  }
}


const useDebitNotes = () => {

  const save = async (data, success) => {
    try {
      const response = await Axois.post('/debit-notes', data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('debit_note_response', {status: 'draft', number: responseData.number});
    }catch(err) {
      console.log(err);
    }
  };

  const postDebitNote = async (number, data, success) => {
    try {
      const response = await Axois.patch('/debit-notes/'+number, data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('debit_note_posted', {status: 'posted'});
    }catch (err) {
      console.log(err);
    }
  }

  const update = async (number, data, success) => {
    try {
      const response = await Axois.put('/debit-notes'+number, data);
      const responseData = await response.data;
      success(responseData.message);
      // EventEmitter.dispatch('saved_invoice_response', {status: 'draft', seo: data.seo});
    }catch(err) {
      console.log(err);
    }
  };

  const updateVendorBill = async (number, data, success) => {
    try {
      const response = await Axois.put('/vendor-bills/'+number, data);
      const responseData = await response.data;
      // success(responseData.message);
      // EventEmitter.dispatch('saved_invoice_response', {status: 'draft', seo: data.seo});
    }catch(err) {
      console.log(err);
    }
  };

  return { save, update, postDebitNote, updateVendorBill };
}


export default useDebitNotes;